import { Component, input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { QrCodeClaimingService } from '../../../services/qr-code-claiming.service';
import { formatMacAddress } from '../../../utils/parse-claim-url';

/**
 * Route that handles claim URLs by storing the MAC/serial and redirecting. Currently handles
 * V1 and V2 of the claim URL, but can support any URLs that contain :serial and :mac params.
 */
@Component({
	selector: 'sh-claim-redirect-route',
	standalone: true,
	template: ''
})
export class ClaimRedirectRouteComponent implements OnInit {
	public readonly serial = input.required<string>();
	public readonly mac = input.required<string>();

	constructor(
		private readonly qrCodeClaimingService: QrCodeClaimingService,
		private readonly router: Router
	) {}

	public ngOnInit(): void {
		this.qrCodeClaimingService.saveScannedQrCode({
			serial: this.serial(),
			mac: formatMacAddress(this.mac())
		});

		this.qrCodeClaimingService.setGoToQrClaimingStepFlag();
		this.router.navigate(['devices', 'add'], { replaceUrl: true });
	}
}
